export const NB_PLAYERS_MAX = 4;
export const AVAILABLE_PLAYERS = [
  "Player 1",
  "Player 2",
  "Player 3",
  "Player 4",
]